import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";
import methodology from '../../../../../Assests/ReportImages/Reportmethodology.png'

const setupMethodology = await fetch(methodology).then(response => response.blob())

const setUpMethodologyImage = new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 675,
        height: 406
    },
});

export const methodologyHeading = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "6.  Methodology",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export const setUpAndMethodology = new Paragraph({
    spacing: { before: 150 },
    alignment: AlignmentType.CENTER,
    children: [setUpMethodologyImage]
})


export const accrualPhase = new Paragraph({
    spacing: { before: 150 },
    children: [
        new TextRun({
            text: "Accrual Phase",
            size: 22,
            color: "c00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false
        })
    ],
})

export const accrualPhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The information gathering stage is about querying a range of sources to determine information that may assist an attacker in gaining access to an organization’s infrastructure. This is a non-intrusive stage where in all the available data is gathered to facilitate the next phases. Apart from the various information gathering tools available on the net, the methods / tools used included:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const accrualPhasebullet1 = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Spidering the application for generating the sitemap ",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const accrualPhasebullet2 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Information gathering about the technologies used in the application ",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const accrualPhasebullet3 = new Paragraph({
    indent: { left: 600 },
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Scanning for the vulnerabilities in the Application",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const acclimatizePhase = new Paragraph({
    spacing: { before: 250 },
    children: [
        new TextRun({
            text: "Acclimatize Phase",
            size: 22,
            color: "c00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false
        })
    ],
})

export const acclimatizePhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "After completion of information gathering about the target system in the previous phase the next step is to identify the vulnerabilities present on the target system using the vulnerability scanners like Burpsuite Pro. ",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
